// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllData = createAsyncThunk('appUsers/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data

})

export const getData = createAsyncThunk('appUsers/getData', async params => {
  console.log("params>>", params)
  const response = await axios.get('/api/users/list/data', params)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const getBillDetail = createAsyncThunk('appUsers/getBillDetail', async id => {
  console.log("id>>>", id)
  const response = await axios.get(`${process.env.REACT_APP_API_URL}admin/allBileDetail/${id}`)
  console.log("Billresponse>>", response)
  return response.data.billDetail
})

export const getAllBiles = createAsyncThunk('appUsers/getAllBiles', async params => {
  //alert(params)
  console.log("params>>", params)
  if (params === 'deposit' || params === 'withdraw') {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}transaction/admindummyTransactionList/${params}`, { params })
    console.log("response>>", response)
    return {
      params,
      allData: response.data.data,
      data: response.data.data,
      totalPages: response.data.data.length
    }
  } else {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}transaction/adminTransactionList/${params}`, { params })
    console.log("response>>", response)
    return {
      params,
      allData: response.data.data,
      data: response.data.data,
      totalPages: response.data.data.length
    }
  } 
})


export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  console.log("getState", getState())
  await axios.get(`${process.env.REACT_APP_API_URL}transaction/approvewalletrequest/${id}`)
  await dispatch(getAllBiles(getState().bills.params))
  // await dispatch(getAllData())
  return id
})


export const deleteApproveUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  console.log("getState", getState())
  await axios.get(`${process.env.REACT_APP_API_URL}transaction/approveaddToWallet/${id}`)
  await dispatch(getAllBiles(getState().bills.params))
  // await dispatch(getAllData())
  return id
})

export const deleteApproveWidrawUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  console.log("getState", getState())
  await axios.get(`${process.env.REACT_APP_API_URL}transaction/AdminApproveWithdrawRequest/${id}`)
  await dispatch(getAllBiles(getState().bills.params))
  // await dispatch(getAllData())
  return id
})


export const appUsersSlice = createSlice({
  name: 'getAllBiles',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      // .addCase(getUserData.fulfilled, (state, action) => {
      //   state.allData = action.payload.allData
      // })
      .addCase(getAllBiles.fulfilled, (state, action) => {
        state.allData = action.payload.allData
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getBillDetail.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appUsersSlice.reducer
